import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { getPosterImageUrl } from '../../../components/Video/NativeVideo/get-poster-image';
import styles from '../../../components/Video/Video.module.scss';
const defaultAnalytics = {};
function NativeVideo({ analytics = defaultAnalytics, asset, componentId, isIos = false, posterimage = null, serverurl, videoLoaded, videoPlayed, videoserverurl, }) {
    const [width, setWidth] = useState();
    const ref = useCallback(node => {
        if (node !== null)
            setWidth(node.offsetWidth);
    }, []);
    const hasPoster = !!posterimage;
    const poster = hasPoster && width ? getPosterImageUrl({ posterimage, serverurl, width }) : null;
    const url = `${videoserverurl}${asset}.m3u8`;
    return (React.createElement("div", { className: styles.ratioOuter, ref: ref },
        React.createElement(ReactPlayer, { "data-testid": "native-video", className: classNames(styles.player, styles.ratioInner), config: {
                file: {
                    forceHLS: !isIos,
                    forceVideo: true,
                },
            }, controls: true, id: componentId, light: hasPoster ? poster : false, onReady: () => videoLoaded === null || videoLoaded === void 0 ? void 0 : videoLoaded(Object.assign(Object.assign({ event: 'video_visible' }, analytics), { asset, componentId, url })), onStart: () => videoPlayed === null || videoPlayed === void 0 ? void 0 : videoPlayed(Object.assign(Object.assign({ event: 'video_play' }, analytics), { asset, componentId, url })), playing: hasPoster, url: url, volume: 0.5 })));
}
NativeVideo.displayName = 'NativeVideo';
NativeVideo.propTypes = {
    analytics: PropTypes.shape({
        analyticsId: PropTypes.string,
    }),
    asset: PropTypes.string.isRequired,
    componentId: PropTypes.string.isRequired,
    isIos: PropTypes.bool,
    posterimage: PropTypes.string,
    serverurl: PropTypes.string.isRequired,
    videoLoaded: PropTypes.func,
    videoPlayed: PropTypes.func,
    videoserverurl: PropTypes.string.isRequired,
};
export default NativeVideo;
//# sourceMappingURL=NativeVideo.js.map